<template>
    <div class="loader">
        <div class="loader-gif">

        </div>
    </div>
</template>
<script setup>
import { defineProps, toRefs } from 'vue';


</script>


<style lang="scss">
.loader {

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #f0f0f0;
        opacity: 0.6;
        z-index: 9;
    }
}

.loader-gif {
    background-image: url('@/assets/img/loading.gif');
    background-repeat: no-repeat;
    background-size: contain;
    width: 50px;
    height: 50px;
    z-index: 999;

}
</style>